<template>
  <div class="ui two column padded centered grid">
    <div class="centered row">
      <div class="six wide column">
        <div class="ui huge center aligned header">Course Syncguid:</div>
        <div class="ui fluid icon input">
          <input type="text" placeholder="Search..." v-model="searchTerm" @keyup.enter="search">
          <i class="search icon" />
        </div>
      </div>
    </div>
    <div v-if="content" class="centered row">
      <div class="ui raised six wide column segment">
        <div class="ui large header">{{ content.title }}</div>
        <div class="ui basic fitted segment"><span class="ui bold text">SyncGuid:</span>{{ content.syncguid }}</div>
        <div class="ui basic fitted description segment scrolling content">{{ content.description }}</div>
        <div class="ui basic fitted flexed segment">
          <div id="authenticate-selector" class="ui toggle checkbox">
            <input type="checkbox" v-model="authenticate">
            <label>Authenticate</label>
          </div>
          <router-link :to="setLaunchLink" target="_blank" class="ui button">Launch Course</router-link>
        </div>
        <div id="container" class="ui basic fitted right aligned segment">
          <a class="ui button" href="https://content-producer-testing.bizlibrary.com" target="_blank">Communication Testing</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentService from '@/services/api/content/content-service';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'List',
  data() {
    return {
      searchTerm: null,
      content: null,
      authenticate: false,
    };
  },
  computed: {
    setLaunchLink() {
      return `/courses/launch?code=${this.content.syncguid}&clientid=btldemoid&standard=AICC&authenticate=${this.authenticate}&aicc_url=https://ri7y9up766.execute-api.us-east-1.amazonaws.com/latest/aicc/track&aicc_sid=${uuidv4()}`;
    },
  },
  methods: {
    search() {
      ContentService.getContentById(this.searchTerm)
        .then(res => {
          this.content = res;
        });
    },
  },
  watch: {
    content(newVal, oldVal) {
      if (!oldVal && newVal && (newVal !== oldVal)) {
        $('#authenticate-selector').checkbox();
        $('#container').html('<object data="https://content-producer-testing.bizlibrary.com/"/>');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ui.bold.text {
  margin-right: 5px;
}
.description {
  max-height: 200px;
  overflow-y: auto;
}
.ui.basic.fitted.flexed.segment {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
object {
  width: 100%;
}
</style>
